import React from 'react';

import TopBanners from '../TopBanners/TopBanners';
import BigBanner from '../BigBanner/BigBanner';
import AdviceBox from '../AdviceBox/AdviceBox';

import './Modules.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const ModuleSlider = ({
  isMobile,
  home,
  tags,
  primaryColor,
  uiVariantBannerHeader,
  uiVariantSlider,
  uiVariantSliderTagsSide,
  hasGoogleAnalytics4Advanced,
  hasGoogleTagManager,
  hasFarmakomMetrics,
  discounted,
  datiFarmacia,
}) => {
  const renderModuleSlider = () => {
    if (isMobile) {
      return renderModuleSliderMobile();
    } else {
      return renderModuleSliderDesktop();
    }
  };

  const renderModuleSliderMobile = () => {
    const {
      sliderTopSlide1Image: slide1Image,
      sliderTopSlide1Link: slide1Link,
      sliderTopSlide1SeoName: slide1SeoName,
      sliderTopSlide2Image: slide2Image,
      sliderTopSlide2Link: slide2Link,
      sliderTopSlide2SeoName: slide2SeoName,
      sliderTopSlide3Image: slide3Image,
      sliderTopSlide3Link: slide3Link,
      sliderTopSlide3SeoName: slide3SeoName,
      sliderTopSlide4Image: slide4Image,
      sliderTopSlide4Link: slide4Link,
      sliderTopSlide4SeoName: slide4SeoName,
      sliderTopSlide5Image: slide5Image,
      sliderTopSlide5Link: slide5Link,
      sliderTopSlide5SeoName: slide5SeoName,
      sliderTopSlide6Image: slide6Image,
      sliderTopSlide6Link: slide6Link,
      sliderTopSlide6SeoName: slide6SeoName,
    } = home;
    const slides = [
      { link: slide1Link, image: slide1Image, seoName: slide1SeoName },
      { link: slide2Link, image: slide2Image, seoName: slide2SeoName },
      { link: slide3Link, image: slide3Image, seoName: slide3SeoName },
      { link: slide4Link, image: slide4Image, seoName: slide4SeoName },
      { link: slide5Link, image: slide5Image, seoName: slide5SeoName },
      { link: slide6Link, image: slide6Image, seoName: slide6SeoName },
    ].filter(slide => !!slide.link && !!slide.image);
    const getLinkLabel = link =>
      link
        .split(datiFarmacia.siteUrl)
        .join('')
        .split('/')
        .filter(part => !!part)
        .map(part => part.split('-').join(' '))
        .join(' -');
    return (
      <div className="hidden-desktop">
        <div className="mobile-module-slider">
          {slides.map((slide, i) => (
            <a
              href={slide.link}
              aria-label={'Vai alla pagina ' + getLinkLabel(slide.link)}
            >
              <ImageDispatcher
                className={`module-slider-image ${i > 0 ? 'lazyload' : ''}`}
                src={slide.image}
                alt={slide.seoName}
              />
            </a>
          ))}
        </div>
      </div>
    );
  };

  const renderModuleSliderDesktop = () => {
    return (
      <div className="hidden-mobile container">
        <TopBanners
          home={home}
          uiVariantBannerHeader={uiVariantBannerHeader}
          uiVariantSliderTagsSide={uiVariantSliderTagsSide}
          discounted={discounted}
        />
        <div
          className="row"
          style={{
            flexDirection:
              uiVariantSliderTagsSide === 'sx' ? 'row-reverse' : 'row',
          }}
        >
          <div className="col-lg-9">
            <BigBanner
              home={home}
              primaryColor={primaryColor}
              rounded={uiVariantSlider === '1'}
              dotsOnRight={uiVariantSlider === '1'}
              uiVariantSlider={uiVariantSlider}
            />
          </div>
          <div className="col-lg-3">
            <AdviceBox
              tags={tags}
              adviceTitle={home.adviceTitle}
              primaryColor={primaryColor}
              uiVariantSlider={uiVariantSlider}
              hasGoogleAnalytics4Advanced={hasGoogleAnalytics4Advanced}
              hasFarmakomMetrics={hasFarmakomMetrics}
              hasGoogleTagManager={hasGoogleTagManager}
            />
          </div>
        </div>
      </div>
    );
  };

  return <>{renderModuleSlider()}</>;
};

export default ModuleSlider;
